.filterTreeTrigger {
  display: inline-flex;
  background-color: var(--surface-soft);
  height: 32px;
  padding: 6px 8px 6px 12px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid var(--border-default);
  cursor: pointer;
  color: var(--text-soft);

  &:hover {
    background-color: var(--surface-hover);
    color: var(--text-default);
  }

  &.active {
    background-color: var(--surface-active);
    border-color: var(--surface-active);
    color: var(--text-default);
  }

  &.showAsHovered {
    background-color: var(--surface-hover);
    color: var(--text-default);
  }
}
